import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import throttle from 'lodash/throttle';
import cx from 'classnames';

import { InlineGrid } from '@marvelapp/marvel-ui/grid';
import PageWrap from '@marvelapp/marvel-ui/page-wrap';

import HeaderLogo from './HeaderLogo';
import HeaderNav from './HeaderNav';
import UpgradeLink from './UpgradeLink';

import generalStyles from './style/general.module.css';
import { isCheckingStatus } from '../../../selectors/user';

class Header extends Component {
  constructor() {
    super();

    this.state = {
      hasScrolled: false,
      isNavOpen: false,
    };

    this.toggleNav = this.toggleNav.bind(this);
    this.handleScroll = throttle(this.handleScroll.bind(this), 50);
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (window.scrollY > 5) {
      this.setState({ hasScrolled: true });
    } else {
      this.setState({ hasScrolled: false });
    }
  }

  toggleNav() {
    const { isNavOpen } = this.state;
    this.setState({ isNavOpen: !isNavOpen });
  }

  render() {
    const { isNavOpen, hasScrolled } = this.state;
    const { isLight, title, isResources } = this.props;

    const headerClassName = cx(generalStyles.header, {
      [generalStyles.default]: !hasScrolled,
      [generalStyles.hasScrolled]: hasScrolled,
      [generalStyles.navOpen]: isNavOpen,
    });

    const headerItemProps = {
      toggleNav: this.toggleNav,
      isNavOpen,
      isLight: hasScrolled ? false : !isNavOpen && isLight,
      isResources,
    };

    const labelClassName = cx('fontSize-m fontWeight-5', {
      'c-white': !hasScrolled && !isResources,
      'c-marvel': hasScrolled && !isResources,
      'c-black': isResources,
    });

    const lineClass = cx(generalStyles.line, {
      'bg-white': !hasScrolled && !isResources,
      'bg-marvel': hasScrolled && !isResources,
      'bg-black': isResources,
    });

    return (
      <header className={headerClassName}>
        <PageWrap size="l">
          <div className={generalStyles.grid}>
            <InlineGrid size="xs">
              <HeaderLogo {...headerItemProps} />
              {title && (
                <InlineGrid size="xs">
                  <div className={lineClass} />
                  <div className={labelClassName}>{title}</div>
                </InlineGrid>
              )}
              <UpgradeLink
                color={isLight && !hasScrolled ? 'white' : 'blue'}
                isVisible={!title}
              />
            </InlineGrid>
            <HeaderNav {...headerItemProps} />
          </div>
        </PageWrap>
      </header>
    );
  }
}

Header.propTypes = {
  isLight: PropTypes.bool,
  title: PropTypes.string,
  isCheckingUserStatus: PropTypes.bool.isRequired,
  isResources: PropTypes.bool,
  setLoggedInStatus: PropTypes.func.isRequired,
  tagLine: PropTypes.bool,
};

Header.defaultProps = {
  isResources: false,
  isLight: false,
  tagLine: false,
};

function mapStateToProps(state) {
  return {
    isCheckingUserStatus: isCheckingStatus(state),
  };
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/components/modules/Header/index.js